import styled from 'styled-components';
import { breakpointNumbers, mediaQueries } from '@general/breakpoints';

export const BreadCrumbContainerStyled = styled.div`
    background-color: #f9f9f9;
`;

export const BodyContainerStyled = styled.div`
    padding-bottom: 34px;
    padding-top: 34px;

    @media (max-width: ${breakpointNumbers.medium - 1}px) {
        padding-bottom: 28px;
        padding-left: 24px;
        padding-right: 24px;
        padding-top: 28px;
    }
`;

export const GridContainerStyled = styled.div`
    margin-top: 24px;

    @media ${mediaQueries.md} {
        display: grid;
        gap: 1.875rem;
        grid-template-columns: repeat(8, minmax(0, 1fr));
        margin-top: 40px;
    }
`;

export const CardsSavedContainerStyled = styled.div`
    margin-top: 20px;

    @media ${mediaQueries.md} {
        margin-top: 40px;
    }
`;

export const FooterMobileContainerStyled = styled.div`
    box-shadow: 0px -8px 12px -8px rgba(87, 87, 87, 0.2);
    padding: 16px 24px;
`;
